// Errors the axios interceptor already answers (refresh or sign-out on 401, ExpiredModal on a locked
// 403), so a screen adds no second message of its own.
export function isHandledElsewhere(err) {
  const status = err?.response?.status
  const code = err?.response?.data?.error?.code
  return status === 401 || (status === 403 && (code === 'TRIAL_EXPIRED' || code === 'SUBSCRIPTION_REQUIRED'))
}

// Refused on the client because another scenario write is still running; nothing was sent.
export const SCENARIO_BUSY_MESSAGE = 'Another change is still saving. Please try again in a moment.'

export class ScenarioBusyError extends Error {
  constructor() {
    super(SCENARIO_BUSY_MESSAGE)
    this.name = 'ScenarioBusyError'
  }
}

// A template copy is made from the server's version of the scenario; refused on the client while
// that version lacks what is on screen (the autosave just failed). Nothing was sent.
export const UNSAVED_CHANGES_MESSAGE = 'Your latest changes are not saved yet. Please try again in a moment.'
// The same, when the server refused that save as invalid (400): waiting will not help (our text).
export const REJECTED_CHANGES_MESSAGE = "We couldn't save your changes. Edit the field to try again."

export class UnsavedChangesError extends Error {
  constructor(message = UNSAVED_CHANGES_MESSAGE) {
    super(message)
    this.name = 'UnsavedChangesError'
  }
}
